import React, { createContext, useContext } from "react";

const SiteContext = createContext(null);

export const SiteContextProvider = ({ value, children }) => (
  <SiteContext.Provider value={value}>{children}</SiteContext.Provider>
);

export const useSiteContext = () => useContext(SiteContext);

export default SiteContext;

